import { render, staticRenderFns } from "./PainelInformativo.vue?vue&type=template&id=e7388124&"
import script from "./PainelInformativo.vue?vue&type=script&lang=js&"
export * from "./PainelInformativo.vue?vue&type=script&lang=js&"
import style0 from "./PainelInformativo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports